// USAPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import DrpEduNavbar from "../../components/DrpEduNavbar";

const USAPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in the USA</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Key Highlights</h2>
          <ul>
            <li>
              <strong>Duration:</strong> 4 to 6 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Bachelor's or Master’s degree</li>
                <li>GRE (optional in many universities)</li>
                <li>TOEFL/IELTS for international students</li>
                <li>Strong academic background + research proposal</li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Fully funded programs (tuition + stipend) via assistantships
                  or fellowships
                </li>
                <li>Stipend: $20,000–$40,000/year</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Key Highlights</h2>
          <ul>
            <li>
              <strong>Duration:</strong> 1 to 3 years (extendable)
            </li>
            <li>
              <strong>Eligibility:</strong> Completed PhD + publications
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>
                  Through PI grants (NIH, NSF, etc.) or university fellowships
                </li>
                <li>Salary: $50,000–$70,000/year</li>
              </ul>
            </li>
            <li>
              <strong>Visa:</strong> J-1 or H-1B for international researchers
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in the USA</h2>
          <ol>
            <li>Massachusetts Institute of Technology (MIT)</li>
            <li>Stanford University</li>
            <li>Harvard University</li>
            <li>California Institute of Technology (Caltech)</li>
            <li>Princeton University</li>
            <li>University of California, Berkeley (UC Berkeley)</li>
            <li>University of Chicago</li>
            <li>Columbia University</li>
            <li>Yale University</li>
            <li>University of California, San Diego (UCSD)</li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default USAPhD;
